import React from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';

import { urls } from '@/urls';
import BatchRunTable from './batch-run-table';

export interface AgentChildRun {
  id: number;
  trigger: string;
  status: string;
  user_email?: string | null;
  user_name?: string | null;
  started_at: string;
  error?: string | null;
  reply?: string | null;
}

export const AGENT_STATUS_COLORS: Record<
  string,
  'success' | 'error' | 'info' | 'warning' | 'default'
> = {
  completed: 'success',
  failed: 'error',
  running: 'info',
  skipped: 'default',
  awaiting_approval: 'warning',
  Completed: 'success',
  Failed: 'error',
  Running: 'info',
};

interface AgentRunsTableProps {
  triggerFilter: 'manual' | 'cron';
  title: string;
  testId: string;
}

export function AgentRunsTable({
  triggerFilter,
  title,
  testId,
}: AgentRunsTableProps) {
  return (
    <BatchRunTable
      listUrl={urls.DevOps.agentBatchRuns}
      detailUrl={urls.DevOps.agentBatchRun}
      title={title}
      testId={testId}
      triggerFilter={triggerFilter}
      statusColors={AGENT_STATUS_COLORS}
      extraColumns={(row) => <TableCell>{row.module ?? '—'}</TableCell>}
      renderChildHeader={() => (
        <TableRow>
          <TableCell>Id</TableCell>
          <TableCell>Trigger</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>User</TableCell>
          <TableCell>Started</TableCell>
        </TableRow>
      )}
      renderChildRow={(child: AgentChildRun) => (
        <TableRow key={child.id}>
          <TableCell>{child.id}</TableCell>
          <TableCell>{child.trigger}</TableCell>
          <TableCell>
            <Chip
              size="small"
              label={child.status}
              color={AGENT_STATUS_COLORS[child.status] ?? 'default'}
            />
          </TableCell>
          <TableCell>
            {child.user_name ?? child.user_email ?? '—'}
          </TableCell>
          <TableCell>
            {new Date(child.started_at).toLocaleString()}
          </TableCell>
        </TableRow>
      )}
      getChildren={(detail) =>
        (detail as { children?: AgentChildRun[] }).children ?? []
      }
    />
  );
}
